var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaybillInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.86989 18.7608C3.04283 19.5683 3.73498 20.1807 4.56079 20.1807H28.8135C29.6393 20.1807 30.3302 19.5677 30.5086 18.7614C30.8971 17.0066 31.3742 15.9352 31.3742 11.0903C31.3742 6.24551 30.8971 5.17405 30.5086 3.41931C30.3302 2.61302 29.6393 2 28.8135 2L4.56078 2C3.73498 2 3.04283 2.61241 2.86989 3.41991C2.48068 5.23728 2 6.41635 2 11.0903C2 15.7643 2.48068 16.9434 2.86989 18.7608Z",
    fill: "#686868",
    stroke: "#686868",
    strokeWidth: 2.475
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.6875,
    cy: 11.0874,
    r: 3.52491,
    fill: "white",
    stroke: "white",
    strokeWidth: 2.475
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25293 6.95703L8.68307 6.93866",
    stroke: "white",
    strokeWidth: 2.475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9517 15.1797L26.3818 15.1613",
    stroke: "white",
    strokeWidth: 2.475,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaybillInactive);
export default __webpack_public_path__ + "static/media/paybillInactive.77a2537935ee5c8b70bd7166f1d2d434.svg";
export { ForwardRef as ReactComponent };